import { useDrop } from 'react-dnd';
import { TaskSection } from '../interfaces/Task';

interface SectionDropZoneProps {
    insertIndex: number;
    onDrop: (sectionId: string, insertIndex: number) => void;
}

export default function SectionDropZone(props: SectionDropZoneProps) {
    const [{ isOver, canDrop }, drop] = useDrop(() => ({
        accept: 'section',
        drop: (item: { sectionId: string; section: TaskSection }) => {
            props.onDrop(item.sectionId, props.insertIndex);
        },
        collect: (monitor) => ({
            isOver: monitor.isOver(),
            canDrop: monitor.canDrop(),
        }),
    }), [props.insertIndex, props.onDrop]);

    const dropZoneStyle = {
        height: isOver && canDrop ? '50px' : '12px',
        backgroundColor: isOver && canDrop ? '#d4edda' : 'transparent',
        border: isOver && canDrop ? '2px dashed #28a745' : 'none',
        borderRadius: '6px',
        transition: 'all 0.2s ease',
        margin: '8px 0',
        position: 'relative' as const,
        opacity: isOver && canDrop ? 1 : 0.2,
    };

    return (
        <div ref={drop as any} style={dropZoneStyle}>
            {isOver && canDrop && (
                <div style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    color: '#28a745',
                    fontStyle: 'italic',
                    fontSize: '14px',
                    fontWeight: 'bold',
                    pointerEvents: 'none',
                    whiteSpace: 'nowrap'
                }}>
                    Drop section here
                </div>
            )}
        </div>
    );
}
